﻿import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../core/language/language.service';
import { DropdownItem } from '../../../core/models/dropdown-item';
import { SharedService } from '../../../shared/shared.service';
import { OfflineDebate } from '../../../core/models/debates/offline-debates/offline-debate';
import { SearchOfflineDebates } from '../../../core/models/debates/offline-debates/search-offline-debates';
import { OfflineDebatesService } from '../offline-debates.service';

@Component({
    selector: 'offline-debates-list',
    templateUrl: './offline-debates-list.component.html',
    styleUrls: ['./offline-debates-list.component.css']
})

export class OfflineDebatesListComponent implements OnInit {
    public offset: number = 0;
    public limit: number = 10;
    public size: number = 0;
    private languageID: number;
    public offlineDebates: OfflineDebate[];
    public searchModel: SearchOfflineDebates;
    public debateStatuses: DropdownItem[] = [];
    public pageNum: number = 1;
    public pageSize: number = this.limit;
    public pathname: string;
    public isDesc: boolean = true;
    public column: string = "";

    constructor(private _offlineDebatesService: OfflineDebatesService,
        private _languageService: LanguageService,
        private _sharedService: SharedService) {
        this.offlineDebates = [];
        this.languageID = this._languageService.selectedLanguageId;
        this.searchModel = new SearchOfflineDebates();
        this.searchModel.languageId = this.languageID;
        this._sharedService.getAllDebateStatusesForDropdown(0, true, this.languageID).subscribe(result => {
            this.debateStatuses = result;
        });
    }

    ngOnInit() {
        this.pathname = '/public-offline-debates/public-offline-debates-list';
        this.search(); 
        this.initSearchModel();
    }

    onLimitChange(newLimit: number) {
        this.offset = 0;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = newLimit;
        this.search();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.search();
    }

    initSearchModel() {
        this.searchModel.languageId = this.languageID;
        this.searchModel.pageNumber = 1;
        this.searchModel.pageSize = 10;
        this.searchModel.debateStatusId = 0;
        this.searchModel.search = null;
        this.searchModel.column = "";
        this.searchModel.isDesc = this.isDesc;
    }

    search() {
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;

        this._offlineDebatesService.searchOfflineDebates(this.searchModel).subscribe(result => {
            this.offlineDebates = result.results;
            this.size = result.rowCount;
        });
    }

    searchClick() {
        this.pageNum = 1;
        this.offset = 0;
        this.search();
    }

    clearSearch() {
        this.pageNum = 1;
        this.pageSize = this.limit;
        this.initSearchModel();
        this.search();
    }

    sort(column: string) {
        this.column = column;
        this.isDesc = !this.isDesc;

        this.searchModel.column = column;
        this.searchModel.isDesc = !this.searchModel.isDesc;
        this.pageNum = 1;
        this.offset = 0;
        this.search();
    }
    downloadPDF() {
        const pdfUrl = "../../../assets/documents/instructions/javneRasprave.pdf";
        const pdfName = 'korisnicke_upute_javne_rasprave.pdf';

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        link.click();
    }
}